
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "InputWithOptions2552810431",
      {"classes":{"root":"InputWithOptions2552810431__root","nativeSelectWrapper":"InputWithOptions2552810431__nativeSelectWrapper","nativeSelect":"InputWithOptions2552810431__nativeSelect","nativeOption":"InputWithOptions2552810431__nativeOption"},"vars":{},"stVars":{"focusBoxShadow":"0 0 0 3px var(--wsr-color-F00, #AADBFC)"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  